module.exports = __webpack_public_path__ + "static/media/drew-beamer-Se7vVKzYxTI-unsplash.d8176578.jpg";